import React, { ReactNode } from 'react';

interface OptionProps {
  currentProduct: string | null;
  optionValue?: string | number;
  className: string;
  /** The caller's `option__selected` class — each offer variant has its own SCSS module. */
  selectedClassName: string;
  productName?: string;
  doOnClick: (optionValue: string | number | undefined, productName: string) => void;
  children: ReactNode;
}

/** Selectable pricing option card, shared by all offer variants. */
function Option({
  currentProduct,
  optionValue,
  className,
  selectedClassName,
  doOnClick,
  children,
  productName = 'defaultProductName',
}: OptionProps) {
  const isSelected = currentProduct === optionValue;

  return (
    <div
      className={isSelected ? `${className} ${selectedClassName}` : className}
      onClick={() => doOnClick(optionValue, productName)}
    >
      {children}
    </div>
  );
}

export default Option;
